import clsx from 'clsx'

import { Link } from '@wartek-id/link'
import { Text } from '@wartek-id/text'

import { formatNumber } from '@/utils/string'
import { CellRenderer } from '@/utils/table'
import {
  trackClickOpenVervalByNpyp,
  trackClickSekolahNaungan,
} from '@/utils/tracker/modules/datainduk'

import { VERVAL_YAYASAN_BASE_URL } from '@/modules/DataInduk/constant'

export const YayasanCellRenderer = ({ row, col, onClickSekolahNaungan }) => {
  const value = row.getValue()
  const originalRowData = row?.row?.original || {}
  const npyp = originalRowData?.npyp

  if (col?.id === 'npyp') {
    return (
      <div
        data-type={col?.id || ''}
        data-clickable="true"
        className="min-w-[80px]"
      >
        <Link
          underline={false}
          rel="noopener noreferrer"
          target="_blank"
          data-testid={`txt-npyp-${npyp}`}
          href={`${VERVAL_YAYASAN_BASE_URL}?yayasan_id=${originalRowData?.yayasanId}&utm_source=portal-satu-data`}
          onClick={() => {
            trackClickOpenVervalByNpyp({
              npyp: value,
            })
          }}
        >
          {value}
        </Link>
      </div>
    )
  }

  if (col?.id === 'namaYayasan') {
    return (
      <div data-type={col?.id || ''} className="min-w-[250px]">
        <Text>{value}</Text>
      </div>
    )
  }

  if (col?.id === 'alamatJalan') {
    return (
      <div data-type={col?.id || ''} className="min-w-[250px]">
        <Text>{value || '-'}</Text>
      </div>
    )
  }

  if (col?.id === 'jenisYayasan') {
    return (
      <div data-type={col?.id || ''} className="min-w-[80px]">
        <Text>{value}</Text>
      </div>
    )
  }

  if (col?.id === 'namaDesa') {
    return (
      <div data-type={col?.id || ''} className="min-w-[150px]">
        <Text>{value || '-'}</Text>
      </div>
    )
  }

  if (col?.id === 'jumlahSekolahNaungan') {
    return (
      <div
        data-type={col?.id || ''}
        className={clsx(
          'min-w-[80px] text-right',
          value > 0 ? 'cursor-pointer' : ''
        )}
        data-clickable="true"
        data-testid={`txt-sek-naungan-${npyp}`}
        onClick={() => {
          if (value > 0) {
            trackClickSekolahNaungan({ npyp: originalRowData?.npyp })
            onClickSekolahNaungan(originalRowData)
          }
        }}
      >
        {value <= 0 ? (
          <Text>-</Text>
        ) : (
          <Link underline={false} as="p">
            {formatNumber(value)}
          </Link>
        )}
      </div>
    )
  }

  return <CellRenderer getValue={row.getValue} />
}
